export const SKIP_ERROR_PAGE_INTERCEPTOR = 'skip-error-page-interceptor' as const;
